Array.prototype.diff = function (array) {
  return this.filter(function (value) { return array.indexOf(value) < 0; });
};

Array.prototype.unique = function () {
  return this.filter(function(value, index, self) {
    return self.indexOf(value) === index;
  });
};
